import type { Process } from "types/types";
import { SingleLineModule } from "./ExpandedTileModules";
import styled from "styled-components/macro";
import { useSelector } from "store/useSelector";
import { useFlightConfig } from "components/DataGetter/FlightConfig/useFlightConfig";
import { startCase } from "lodash";
import { useSettings } from "contexts/SettingsManager/SettingsManager";

/** Expanded Tile module showing count (netOutput) */
export function TileCountModule({ process }: { process: Process }) {
  const dataDumpForProcess = useSelector(
    state => state.legacy.dataDumpsFullRangeByProcess[process.id]
  );
  const [
    {
      general: {
        expandedProcessTileCountCustomKey,
        expandedProcessTileCompactMode,
      },
    },
  ] = useFlightConfig();
  const count =
    dataDumpForProcess?.[expandedProcessTileCountCustomKey || "netOutput"];
  const isLongCount = String(count).length > 9; // "undefined" = length 9
  const loading = !(count || count === 0);
  const { tileScaleMultiplier } = useSettings();
  return (
    <SingleLineModule
      loading={loading}
      showThisShiftIndicator={!expandedProcessTileCompactMode}
      data={
        <TileCountStyles
          className={count ? "count" : ""}
          $tileScaleMultiplier={tileScaleMultiplier ** 0.45}
        >
          <div className="countText">
            {expandedProcessTileCountCustomKey
              ? startCase(expandedProcessTileCountCustomKey).split(" ")[0]
              : isLongCount
                ? "Ct."
                : "Count:"}
          </div>
          <div className="countValue">
            {count || count === 0 ? Math.round(Number(count)) : "--"}
          </div>
        </TileCountStyles>
      }
    />
  );
}

const TileCountStyles = styled.div<{ $tileScaleMultiplier: number }>`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0 ${props => 1 * props.$tileScaleMultiplier}em;
  box-sizing: border-box;
  .countText {
    font-weight: normal;
  }
  .countValue {
    font-weight: bold;
  }
`;
